import cx from 'clsx';
import { PropsWithChildren } from 'react';

import classes from './contentWrap.module.css';

export const ContentWrap = ({ children, className }: PropsWithChildren<{ className?: string }>) => {
  return <div className={cx('bg-white rounded-xl', classes.container, className)}>{children}</div>;
};
